export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? "https://practicum-group.ru";
export const SITE_NAME = "Practicum";
export const SITE_LOCALE = "ru_RU";
export const SITE_LANG = "ru";
